// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a16622e7","239":"feba9b97","667":"a8969b2d"}[chunkId] + ".chunk.js";
};